import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Button, Col, message, Result, Skeleton, Tabs } from 'antd';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
// import BrandsTableComponent from '../../components/Admin/Brands/BrandsTableComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import BrandsCompaniesTableComponent from '../../components/Admin/Brands/BrandsCompaniesTableComponent';
import { Link, useParams, useHistory } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import CampaignStatsComponent from '../../components/Admin/Brands/Company/CampaignStatsComponent';
import AddBalanceComponent from '../../components/Admin/Brands/Company/AddBalanceComponent';
import BankDetailsComponent from '../../components/Admin/Brands/Company/BankDetailsComponent';
import { GetACompanyDetails } from '../../apis/Admin/Brands/GetACompanyDetails';
import { GetACompanyOverview } from '../../apis/Admin/Brands/GetACompanyOverview';
import CampaignsTableComponent from '../../components/Admin/Brands/Company/CampaignsTableComponent';
import CampaignTxnComponent from '../../components/Admin/Brands/Company/CampaignTxnComponent';

const { TabPane } = Tabs;
export const AdminBrandsCompaniesDetailPage = () => {
  const [user] = useGlobalState('user');
  const params = useParams();
  const history = useHistory();
  const [compData, setCompData] = useState({
    wallet: 'n/a',
    companyname: 'n/a',
  });
  const [compOverview, setCompOverview] = useState({
    pager: {
      page: 1,
      limit: 10,
    },
  });


  const companyDetails = () =>{
    GetACompanyDetails(user.accessToken, params.companyId).then(({ status, response })=>{
      console.log('response a company -->', response);
      if (status === 200) {
        setCompData({
          ...compData,
          ...response,
        });
      }
    });
  };
  const companyOverview = (page, limit) =>{
    const _data = {
      companyId: params.companyId,
      page,
      limit,
    };
    GetACompanyOverview(user.accessToken, _data).then(({ status, response })=>{
      console.log('response a company overview -->', response);
      if (status=== 200) {
        setCompOverview({
          ...compOverview,
          ...response,
        });
      }
    });
  };

  useEffect(()=>{
    companyDetails();
  }, []);
  useEffect(()=>{
    const { page, limit } = compOverview.pager;
    companyOverview(page, limit);
  }, [compOverview.pager]);


  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="px-3 py-2 sticky">
        <h6 className="m-0">
          <a className="stat_over_header_title--back cursor-pointer"
            onClick={history.goBack}><BiArrowBack/></a>
          <strong className="pl-2">{compData.companyname}</strong> Company Details
        </h6>
      </TopSubHeaderComponent>
      <div className="d-flex flex-wrap my-2 px-2">
        <CampaignStatsComponent className="col-md-6 my-2 px-2"
          campStats={{
            active: compOverview.active_campaigns || 0,
            completed: compOverview.completed_campaigns || 0,
            published: compOverview.published_campaigns || 0,
            approved: compOverview.approved_campaigns || 0,
            updatedAt: compOverview.updatedAt,
          }}/>
        <AddBalanceComponent className="col-md-3 my-2 px-2"
          balance={compOverview.wallet && compOverview.wallet.balance || 0}
          companyDetails={companyDetails}
        />
        <BankDetailsComponent className="col-md-3 my-2 px-2"
          bankDetails={compOverview.wallet && compOverview.wallet.paymentmethods || {} }
        />
        <div className="col-md-12 my-2 px-2">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Campaign List"
              key="1">
              {
                compOverview.campaigns &&
                                <CampaignsTableComponent campObj={compOverview.campaigns}
                                  companyOverview={companyOverview}
                                />
              }
            </TabPane>
            <TabPane tab="Transactions"
              key="2">
              {/* Content of Tab Pane 2 */}
              {
                compOverview.transactions &&
                                <CampaignTxnComponent txnObj={compOverview.transactions}
                                // companyOverview={companyOverview}
                                />
              }
            </TabPane>
          </Tabs>
        </div>
      </div>
    </BaseLayoutComponent>
  );
};
